// 先方納品とは別にaemで追加したjs処理

/**
 * list-2で足りないliを追加する
 * justify-content: space-between;で作られており、個数が合わないとレイアウトが崩れるため
 */
const ajustList2Count = () => {

    let list_num = 0;

    // 商品一覧とtopとで表示個数が違うのでここで判定
    if($('body').hasClass('top')) {

        // topは1列4個表示
        list_num = 4;

    } else if($('body').hasClass('special') && $('body').hasClass('detail')) {

        // 特集詳細は5件
        list_num = 5;

    } else {

        // 商品一覧は1列3個表示
        list_num = 3;
    }

    // 現在の表示数
    const NOW_LIST_COUNT = $('.js-adjust-list2 .list-2__list').length;

    // 足りない個数を計算
    const SHORTNESS_COUNT = list_num - (NOW_LIST_COUNT % list_num);

    // 足りないliを追加する
    if(SHORTNESS_COUNT > 0) {
        for(let i = 0; i < SHORTNESS_COUNT; i++) {
            $('.js-adjust-list2').append('<li class="list-2__list list-2__list--empty"></li>');
        }
    }
}

/**
 * banner-listで足りないliを追加する
 * justify-content: space-between;で作られており、個数が合わないとレイアウトが崩れるため
 */
const ajustBannerList2Count = () => {
    let list_num = 3;

    // 現在の表示数
    const NOW_LIST_COUNT = $('.js-adjust-banner-list .banner-list__list').length;

    // 足りない個数を計算
    const SHORTNESS_COUNT = list_num - (NOW_LIST_COUNT % list_num);

    // 足りないliを追加する
    if(SHORTNESS_COUNT != NOW_LIST_COUNT) {
        for(let i = 0; i < SHORTNESS_COUNT; i++) {
            $('.js-adjust-banner-list').append('<li class="banner-list__list banner-list__list--empty"></li>');
        }
    }
}

/**
 * 商品詳細での画像の拡大
 */
const imgZoom = () => {
    var windowWidth = $(window).width();
    var windowSm = 768;
    if (windowWidth <= windowSm) {

    } else {
        $(".zoomimg .item__slider-img").zoom();
    }
}

/**
 * SP時のMENU / Category押下時のカテゴリ表示
 */
const initSpMenuShowCategory = () => {

    $('.js-show-category').on('click', function(e){
        e.preventDefault();
        $(this).next('.header__nav-sp--cate').slideToggle(200);
    })

}

/**
 * SP時のvh調整
 */
const setFillHeight = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}

$(function(){

    if( $('body').hasClass('top')  ||
        $('body').hasClass('item') ||
        ($('body').hasClass('special') && $('body').hasClass('detail'))
    ){
        // 商品一覧とtopと特集詳細のみで実行
        ajustList2Count();
    }

    if($('body').hasClass('store-list')) {
        // STORE一覧でのみ実行
        ajustBannerList2Count();
    }

    // 商品詳細の画像拡大
    imgZoom();

    // SP MENUのカテゴリ初期化
    initSpMenuShowCategory();

    // 初期化
    setFillHeight();

});

// 画面のサイズ変動があった時に高さを再計算する
window.addEventListener('resize', setFillHeight);
